import axios from 'axios'

class AcessoSistemaApiClient {

    async buscarAcessosSistemas() {
        return axios.get('api/acessosSistemas')
    }

}

export default new AcessoSistemaApiClient()
